import { z } from 'zod';
import { VENDOR_CATEGORIES, VENDOR_STATUSES } from '../constants.js';
import {
  auditFields,
  centsSchema,
  currencySchema,
  isoDateSchema,
  notesText,
  optionalText,
  shortText,
  ulidSchema,
  urlSchema,
} from '../common.js';

export const paymentSchema = z.object({
  paymentId: ulidSchema,
  label: shortText,
  amountCents: centsSchema,
  dueDate: isoDateSchema.optional(),
  paidAt: isoDateSchema.optional(),
  /** Set when a reminder schedule exists, so it can be deleted on payment. */
  reminderScheduleName: z.string().max(64).optional(),
});
export type Payment = z.infer<typeof paymentSchema>;

export const vendorSchema = z.object({
  type: z.literal('Vendor'),
  wedId: ulidSchema,
  vendorId: ulidSchema,
  name: shortText,
  category: z.enum(VENDOR_CATEGORIES).default('other'),
  contactName: optionalText,
  contactEmail: z.string().trim().email().max(254).optional(),
  contactPhone: z.string().trim().max(40).optional(),
  website: urlSchema.optional(),
  instagram: z.string().trim().max(40).optional(),
  quoteCents: centsSchema.optional(),
  depositCents: centsSchema.optional(),
  currency: currencySchema,
  status: z.enum(VENDOR_STATUSES).default('researching'),
  payments: z.array(paymentSchema).max(50).default([]),
  contractDocIds: z.array(ulidSchema).max(20).default([]),
  notes: notesText,
  ...auditFields,
});
export type Vendor = z.infer<typeof vendorSchema>;

export const createVendorSchema = vendorSchema
  .omit({
    type: true,
    wedId: true,
    vendorId: true,
    createdAt: true,
    updatedAt: true,
    updatedBy: true,
  })
  .partial()
  .required({ name: true });
export type CreateVendorInput = z.infer<typeof createVendorSchema>;
export const updateVendorSchema = createVendorSchema.partial();

export const createPaymentSchema = paymentSchema.omit({ paymentId: true });
export type CreatePaymentInput = z.infer<typeof createPaymentSchema>;
